<template>
    <li class="clearfix">
        <div class="message-data text-right">
            <span class="message-data-time">{{ dateOutput }}</span>
            <!-- <img
                src="https://bootdey.com/img/Content/avatar/avatar7.png"
                alt="avatar"
            /> -->
        </div>
        <div class="message" :class="event.representative ? 'other-message float-right' : 'my-message'">
            {{ event.messageText }}
        </div>
    </li>
</template>

<script>
import moment from 'moment';
export default {
    props: {
        event: Object
    },
    computed: {
        dateOutput() {
            var momentObject = moment(this.event.createdTime);
            var timeDisplayed = momentObject.format('hh:mm');
            if (this.event.createdTime > moment().startOf('day')) {
                timeDisplayed += ', Today';
                return timeDisplayed;
            }
            return timeDisplayed + ', ' + momentObject.format('MMMM Do, YYYY')
        }
    }
};
</script>
